// Centralized site configuration
// Handles both development (localhost) and production (livelovespain.com) environments

export const SITE_ORIGIN = (typeof window !== 'undefined' && window.location?.origin) 
  || process.env.REACT_APP_SITE_ORIGIN 
  || 'https://livelovespain.com';

export const getSiteUrl = (path = '') => {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_ORIGIN}${cleanPath}`;
};

export const getLocalizedSiteUrl = (path = '', locale = 'en') => {
  const localePrefix = locale === 'en' ? '' : `/${locale}`;
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_ORIGIN}${localePrefix}${cleanPath}`;
};





